/* Thermite Tactical tire finder legacy shim.
   The active tire search is rendered by blocks/ai_gen_block_c4d6680.liquid.
   This asset is intentionally inert so the old direct-browser Gemini widget
   cannot replace the live prompt-box block after page load. */
(function () {
  'use strict';
  window.ThermiteLegacyTireFinderDisabled = true;
})();
